import { createAction } from 'redux-actions';
export const FETCH_EXCHANGE_VARIANTS = 'EXCHANGE/FETCH_EXCHANGE_VARIANTS';
export const FETCH_EXCHANGE_PRICE = 'EXCHANGE/FETCH_EXCHANGE_PRICE';
export const ADD_SELECTED_FLIGHT = 'EXCHANGE/ADD_SELECTED_FLIGHT';
export const SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID = 'EXCHANGE/SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID';
export const REMOVE_LAST_SELECTED_FLIGHT = 'EXCHANGE/REMOVE_LAST_SELECTED_FLIGHT';
export const SET_EXCHANGE_VARIANTS = 'EXCHANGE/SET_EXCHANGE_VARIANTS';
export const SET_EXCHANGE_VARIANT_PRICES = 'EXCHANGE/SET_EXCHANGE_VARIANT_PRICES';
export const CLEAR_EXCHANGE_VARIANTS = 'EXCHANGE/CLEAR_EXCHANGE_VARIANTS';
export const fetchExchangeVariants = createAction(FETCH_EXCHANGE_VARIANTS);
export const fetchExchangePrice = createAction(FETCH_EXCHANGE_PRICE);
export const setExchangeVariants = createAction(SET_EXCHANGE_VARIANTS);
export const setExchangeVariantPrices = createAction(SET_EXCHANGE_VARIANT_PRICES);
export const addSelectedFlight = createAction(ADD_SELECTED_FLIGHT);
export const setActualSelectedFlightPriceId = createAction(SET_ACTUAL_SELECTED_FLIGHT_PRICE_ID);
export const removeLastSelectedFlight = createAction(REMOVE_LAST_SELECTED_FLIGHT);
export const clearExchangeVariants = createAction(CLEAR_EXCHANGE_VARIANTS);
